// General
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, FormArray, FormGroupDirective, NgForm, UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'; // Actualización aquí
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';

// Error
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. **/
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

// Servicio
import { ValidacionPagosService } from 'src/app/services/validacion-pagos.service';
import { ControlEscolarService } from 'src/app/services/control-escolar.service';

// Tabla
import { MatPaginator, PageEvent } from '@angular/material/paginator'; // Actualización aquí
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table'; // Actualización aquí

// Fin Tabla
// Detectar cambios de archivos
import { ChangeDetectorRef } from '@angular/core'; // Detectar cambios
import { ReciboComponent } from 'src/app/modales/recibo/recibo.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
@Component({
    selector: 'app-gt-solicitudes-validacion-pagos',
    templateUrl: './gt-solicitudes-validacion-pagos.component.html',
    styleUrls: ['./gt-solicitudes-validacion-pagos.component.scss'],
    providers: [ValidacionPagosService, ControlEscolarService],
    standalone: false
})
export class GtSolicitudesValidacionPagosComponent implements OnInit {


  public idAlumno: number = +localStorage.getItem('alumno');
  //public idCiclo: number = 3;

  /*tabla*/
  public length: number = 100;;
  public pageSize: number = 10;
  public pageSizeOptions: Array<number> = [5, 10, 25, 100];
  public page: number = 1;
  public displayedColumns: any =[
    '_id', 
    '_alumno',
    '_nombre',
    'gyn',
    //'grado',
    //'grupo',
    '_f_s',
    //'t_p',
    '_estado',
    '_v_solicitud'
    //'eliminar'
  ];
  public dataSource: any;
  /*fin tabla*/
  public isLoading: boolean = false;
  public laravelapiStorage: any;
  public t: any;


  @Input() id_alumno: number = +localStorage.getItem('alumno');
  @Input() id_ciclo: number = 3;

  public id_alumno_pro: number = -1;
  public id_ciclo_pro: number = -1;

  public ciclos: any = [];

  public expandedElement: any;
  public isExpansionDetailRow: any;


  constructor(
    private fb: UntypedFormBuilder,
    public  _dialog: MatDialog,
    private _ValidacionPagosService: ValidacionPagosService,
    private _ControlEscolarService: ControlEscolarService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cdRef:ChangeDetectorRef,

    private dialog:MatDialog,
  ){ 
    this.getConsultarCiclos();
    this.postConsultaTicketSolicitudesPapa(1);
    //this.laravelapiStorage = this._ValidacionPagosService.getLaravelApiStorageTutores();
  }

  ngOnInit(): void {
    console.log(localStorage.getItem('alumno')  );
  }

  public postConsultaTicketSolicitudesPapa(page: number){

  this.page = page;
    this.isLoading = true;
    this._ValidacionPagosService.postConsultaTicketSolicitudesPapa(this.page, this.pageSize, 0, this.id_ciclo_pro).subscribe(
      (response: any) => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this.length = response.data.total;
          this.dataSource = response?.data?.data;
        }
      },
      (error: any) => {console.log(<any>error);
        this.isLoading = false;
      });
  }

  public getConsultarCiclos(){
    this.isLoading = true;
    this._ControlEscolarService.getConsultarCiclos().subscribe(
      (response: any) => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this.ciclos = response.data;
        }
      },
      (error: any) => {console.log(<any>error);
        this.isLoading = false;
      });
  }

  /*public postEliminarDocumentosOrg(id: number){
    this.isLoading = true;
    this._ControlEscolarService.postEliminarDocumentosOrg({numero_documento: id}).subscribe(
      response => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Operación Exitosa', mensaje: response.mensaje, icon:'correct'}});
          this.postConsultaTicketSolicitudesPapa();
        }else{
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Error', mensaje: response.mensaje, icon:'error'}});
        }
      },
      error => {console.log(<any>error);
        this._dialog.open(MessageBoxComponent, { disableClose: true ,data: {titulo: 'Error', mensaje: 'Error con el Servicio.', icon:'error'}});
        this.isLoading = false;
      });
  }*/

  ngAfterContentChecked() {
    this.t = new Date().getTime();
    this._cdRef.detectChanges();    

    this.id_alumno = +localStorage.getItem('alumno');

    if(this.id_alumno != this.id_alumno_pro || this.id_ciclo != this.id_ciclo_pro){
      console.log('cambios');
      this.id_alumno_pro = this.id_alumno;
      this.id_ciclo_pro = this.id_ciclo;
      this.postConsultaTicketSolicitudesPapa(1);

    }


  }

  public pageEvent(event: any){
    console.info(event);
    this.pageSize = event.pageSize;
    this.postConsultaTicketSolicitudesPapa(event.pageIndex + 1);
  }

  public consultandoTicket(data: any){
      
        
          
          const dialogRef = this.dialog.open(ReciboComponent, {
            width: '30em',
            data: data
          });

          dialogRef.afterClosed().subscribe(result => {
            // This is intentional
          });
        
      
    
  }

}
